module.exports = __webpack_public_path__ + "img/iriomote_3.b8bf284b.jpg";